package org.example.zone360.pages.coachDetails.sessionAllDetails.emotionsBox

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.components.CustomSpacer
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.SessionDataDetailsResponse
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun EmotionsBox(
    sessionData: GetSessionsData,
    sitePalette: SitePalette,
    breakpoint: Breakpoint
) {
    val emotions = sessionData.sementics.emotions
    Box(
        modifier = Modifier.fillMaxWidth()
            .height(170.px)
            .margin(top = 15.px)
            .borderRadius(12.px)
            .border(
                1.px,
                style = LineStyle.Solid,
                color = sitePalette.coachDetailsBoxBorder.rgb
            )
            .padding(16.px)
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.textFieldTextColor.rgb.copyf(alpha = 0.1f)
            )
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            SectionTitle("Emotion")

            val emotionDisplayMap = mapOf(
                "Anger" to "Frustration",
                "Disgust" to "Disapproval",
                "Fear" to "Concern",
                "Joy" to "Joy",
                "Sadness" to "Disappointment"
            )

            val topEmotions = emotions
                .sortedByDescending { it.percentage }
                .take(3)
            Column(
                modifier = Modifier.gap(8.px).fillMaxWidth().margin(bottom = 10.px)

            ) {
                val baseColor = Palette.NeutralColor.rgbLight
                val highestPercentage = topEmotions.maxByOrNull { it.percentage }?.percentage

                topEmotions.forEachIndexed { index, emotion ->
                    val displayName = emotionDisplayMap[emotion.label] ?: emotion.label
                    val isTop = emotion.percentage == highestPercentage
                    val alpha = when (index) {
                        0 -> 1.0f
                        1 -> 0.73f
                        2 -> 0.56f
                        else -> 0.4f
                    }

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "${emotion.emoji} $displayName",
                            width = 140.px,
                            fontSize = 14.px,
                            fontFamily = Constants.IBM_FONT
                        )
                        CustomSpacer(10.px)
                        Box(
                            modifier = Modifier
                                .width((emotion.percentage * 2.38).px) // scale: 238 / 100
                                .height(16.px)
                                .borderRadius(
                                    bottomRight = if (isTop) 0.px else 2.92.px,
                                    topRight = if (isTop) 2.92.px else 0.px,
                                    topLeft = if (isTop) 2.92.px else 0.px
                                )
                                .backgroundColor(baseColor.copyf(alpha = alpha))
                        )
                        FieldTitleTextNormalSimple(
                            text = "${emotion.percentage}%",
                            fontSize = 12.px,
                            fontFamily = Constants.IBM_FONT,
                            marginLeft = 5.px
                        )
                    }
                }
            }
        }
    }
}
